import { Grid, MenuItem, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dayjs } from 'dayjs';
import { errorHandler } from 'lib/functions/errors';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { getCompanyFunds } from '../../api/funds';

export interface Fund {
  id: string;
  name: string;
}

export interface FiltersProps {
  selectedFund: string | undefined;
  onFundChange: (fund: string | undefined) => void;
  startDate: Dayjs;
  onStartDateChange: (date: Dayjs) => void;
  endDate: Dayjs;
  onEndDateChange: (date: Dayjs) => void;
}
type FundOption = {
  value: string;
  label: string;
};

export const Filters: React.FC<FiltersProps> = ({
  selectedFund,
  onFundChange,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
}) => {
  const dispatch = useDispatch();
  const [fundOptions, setFundOptions] = useState<FundOption[]>([]);

  const fetchFunds = async () => {
    try {
      const funds = await getCompanyFunds(dispatch);
      const fundOptions = funds.map((fund: Fund) => ({
        value: fund.id,
        label: `${fund.name} (${fund.id})`,
      }));
      setFundOptions(fundOptions);
    } catch (error) {
      errorHandler(dispatch, error);
    }
  };

  useEffect(() => {
    void fetchFunds();
  }, []);

  return (
    <Grid container spacing={1.5} sx={{ px: 3 }}>
      <Grid item xs={12} sm={4}>
        <TextField
          select
          fullWidth
          size="small"
          label="Fondo"
          value={selectedFund ?? ''}
          onChange={(e) => onFundChange(e.target.value || undefined)}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: 40,
            },
          }}
        >
          <MenuItem value="" disabled>
            Seleccionar fondo
          </MenuItem>
          {fundOptions.map((fund) => (
            <MenuItem key={fund.value} value={fund.value}>
              {fund.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={4}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Fecha Inicial"
            value={startDate}
            onChange={(date) => date && onStartDateChange(date)}
            maxDate={endDate}
            slotProps={{
              textField: {
                fullWidth: true,
                size: 'small',
                sx: {
                  '& .MuiOutlinedInput-root': {
                    height: '40px',
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={4}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Fecha Final"
            value={endDate}
            onChange={(date) => date && onEndDateChange(date)}
            minDate={startDate}
            slotProps={{
              textField: {
                fullWidth: true,
                size: 'small',
                sx: {
                  '& .MuiOutlinedInput-root': {
                    height: '40px',
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
};
